import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface ICopy {
  key: string;
  params?: any;
}

@Pipe({ name: 'i2gTranslate' })
export class I2gTranslate implements PipeTransform {
  constructor(private _translateService: TranslateService) {}

  transform(copy: ICopy | string): string {
    return typeof copy === 'string'
      ? copy
      : this._translateService.instant(copy.key, copy.params);
  }
}
